module.exports = __webpack_public_path__ + "img/icon@2x (2).83f5b41a.png";